export const BILL_FETCH_ERROR =
  'Não conseguimos carregar os dados da cobrança :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com nosso suporte pelo chat dentro do sistema.';

export const BILL_SAVE_ERROR =
  'Não conseguimos criar sua cobrança :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com nosso suporte pelo chat dentro do sistema.';
